import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowDownSquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconArrowDownSquare"><Path fillRule="evenodd" clipRule="evenodd" d="M21 21H3V3H21V21ZM11.25 7V14.4395L8.75 11.9395L7.68945 13L12 17.3105L16.3105 13L15.25 11.9395L12.75 14.4395V7H11.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowDownSquare;
